/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Shipment } from '../models/Shipment';
import type { ShippingCalculation } from '../models/ShippingCalculation';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShipmentService {
    /**
     * Create a new shipment
     * @param requestBody
     * @returns Shipment Shipment created successfully
     * @throws ApiError
     */
    public static postShipment(
        requestBody: {
            /**
             * ID of the package to ship (mutually exclusive with CombPackageId)
             */
            PackageId?: number;
            /**
             * ID of the combined package to ship (mutually exclusive with PackageId)
             */
            CombPackageId?: number;
            /**
             * Receiver address ID
             */
            AddressId?: number;
            /**
             * Special instructions for shipment
             */
            note?: string;
        },
    ): CancelablePromise<Shipment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/shipment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request - Package id or combination package id is required, Package already shipped, Package/Address not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get all shipments
     * For admin users, returns all shipments. For regular users, returns only their own shipments.
     * @param search Search shipments by order ID or user email
     * @param startDate Filter shipments created from this date
     * @param endDate Filter shipments created until this date
     * @param state Filter shipments by state
     * @returns Shipment Successfully retrieved shipments
     * @throws ApiError
     */
    public static getShipment(
        search?: string,
        startDate?: string,
        endDate?: string,
        state?: 'DRAFT' | 'REQUESTED' | 'APPROVED' | 'REJECTED' | 'DONE',
    ): CancelablePromise<Array<Shipment>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/shipment',
            query: {
                'search': search,
                'startDate': startDate,
                'endDate': endDate,
                'state': state,
            },
            errors: {
                400: `Invalid state value`,
                403: `Access denied`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get shipment details by ID
     * For admin users, returns any shipment. For regular users, returns only their own shipments.
     * @param id
     * @returns any Successfully retrieved shipment with tracking details
     * @throws ApiError
     */
    public static getShipment1(
        id: number,
    ): CancelablePromise<(Shipment & {
        /**
         * Tracking information from order management service
         */
        trackingDetails?: Record<string, any> | null;
    })> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/shipment/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Access denied`,
                404: `Shipment not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Update shipment details
     * For admin users, can update any shipment. For regular users, can only update their own shipments.
     * @param id
     * @param requestBody
     * @returns Shipment Shipment updated successfully
     * @throws ApiError
     */
    public static putShipment(
        id: number,
        requestBody: {
            /**
             * Shipment cost
             */
            cost?: number;
            /**
             * Shipment state
             */
            state?: 'REQUESTED' | 'APPROVED';
        },
    ): CancelablePromise<Shipment> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/shipment/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Access denied`,
                404: `Shipment not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Calculate shipping cost
     * @param requestBody
     * @returns any Shipping cost calculated successfully
     * @throws ApiError
     */
    public static postShipmentCalculate(
        requestBody: ShippingCalculation,
    ): CancelablePromise<{
        /**
         * Calculated shipping cost
         */
        cost?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/shipment/calculate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request data`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Track a shipment
     * @param requestBody
     * @returns any Tracking information retrieved
     * @throws ApiError
     */
    public static postShipmentTrack(
        requestBody: {
            trackingNumber?: string;
            carrier?: string;
        },
    ): CancelablePromise<{
        trackingEvents?: Array<Record<string, any>>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/shipment/track',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Tracking number not found`,
                500: `Internal server error`,
            },
        });
    }
}
